/**
 * @file
 * Provide the readmore-behavior.
 *
 * When an element contains too much copytext to display directly on frontend.
 * This behavior adds a functionality to expand and collapse the copytext.
 * It uses a "js-readmore"-class as selector for the wrapping container and
 * a "js-readmore-trigger"-class as selector for the trigger-element.
 *
 * When the user click on "js-readmore-trigger", the container get the class
 * "is-open" to expand the content area and switch the trigger-elements.
 *
 * e.g.:
 *
 * <div class="readmore js-readmore">
 *   <p>Lorem ipsum dolor ... </p>
 *   <div class="readmore__trigger js-readmore-trigger">
 *     <span class="readmore__trigger__more">Show more</span>
 *     <span class="readmore__trigger__less">Show less</span>
 *   </div>
 * </div>
 */

(function ($, Drupal) {
  Drupal.behaviors.readmore = {
    attach: function attach(context) {
      $('.js-readmore').each(function () {
        let $element = $(this);
        let readmoreHeight = $element.find('.readmore__content').outerHeight();

        if (readmoreHeight < 300) {
          $element.addClass('is-open').addClass('is-static');
          $element.find('.js-readmore-trigger').addClass('is-hidden-readmore-trigger');
        } else {
          $element.addClass('readmore');
        }

        once('awReadMore', '.js-readmore-trigger', context).forEach(function(currentElement) {
          currentElement.addEventListener('click', function(event) {
            event.preventDefault();
            readmoreHeight = $(this).parents('.js-readmore').find('.readmore__content').outerHeight();
            const $container = $(this).parents('.js-readmore');

            $container.toggleClass('is-open').css('height', readmoreHeight + 80);
          });
        });
      });

      // Adjust height of open readmore-components on window resize
      let window_width_read_more = $(window).width();
      let setReadMoreHeight = debounce(function() {
        let new_window_width = $(window).width();
        if (new_window_width !== window_width_read_more) {
          $('.js-readmore').each(function () {
            let $element = $(this);
            let readmoreHeight = $element.find('.readmore__content').outerHeight();

            if ($element.hasClass('is-open')) {
              $element.css('height', readmoreHeight + 80);
            }
          });
          window_width_read_more = new_window_width;
        }
      }, 250);
      $(window).on('resize', setReadMoreHeight);

    }
  };
})(jQuery, Drupal);
